module.exports = __webpack_public_path__ + "static/img/1726646697427.60169aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1726646697427.jpg
// module id = lc4n
// module chunks = 1